import { DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin } from "/var/lib/cromi-trusted/builds/vNDFPmo8N/0/cromi/cromi.su/node_modules/.pnpm/@unhead+vue@2.0.19_vue@3.5.33_typescript@5.9.3_/node_modules/@unhead/vue/dist/plugins.mjs";
export default {
  disableDefaults: true,
  disableCapoSorting: false,
  plugins: [DeprecationsPlugin, PromisesPlugin, TemplateParamsPlugin, AliasSortingPlugin],
}